import axios from '../axios'
import {
    PAYMENT_TYPE_LIST_REQUEST, PAYMENT_TYPE_LIST_SUCCESS, PAYMENT_TYPE_LIST_FAIL,
    PAYMENT_TYPE_DETAILS_REQUEST, PAYMENT_TYPE_DETAILS_SUCCESS, PAYMENT_TYPE_DETAILS_FAIL,
    PAYMENT_TYPE_CREATE_REQUEST, PAYMENT_TYPE_CREATE_SUCCESS, PAYMENT_TYPE_CREATE_FAIL,
    PAYMENT_TYPE_UPDATE_REQUEST, PAYMENT_TYPE_UPDATE_SUCCESS, PAYMENT_TYPE_UPDATE_FAIL,
    PAYMENT_TYPE_DELETE_REQUEST, PAYMENT_TYPE_DELETE_SUCCESS, PAYMENT_TYPE_DELETE_FAIL,
    USER_PAYMENT_METHOD_LIST_REQUEST, USER_PAYMENT_METHOD_LIST_SUCCESS, USER_PAYMENT_METHOD_LIST_FAIL,
    USER_PAYMENT_METHOD_ADD_REQUEST, USER_PAYMENT_METHOD_ADD_SUCCESS, USER_PAYMENT_METHOD_ADD_FAIL,
    USER_PAYMENT_METHOD_DELETE_REQUEST, USER_PAYMENT_METHOD_DELETE_SUCCESS, USER_PAYMENT_METHOD_DELETE_FAIL,
} from '../constants/paymentConstants'


export const listPaymentTypes = () => async (dispatch, getState) => {
    try {
        dispatch({ type: PAYMENT_TYPE_LIST_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const config = { headers: { Authorization: `Bearer ${userInfo.token}` } }
        const { data } = await axios.get('/api/payment-types/', config)
        dispatch({ type: PAYMENT_TYPE_LIST_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: PAYMENT_TYPE_LIST_FAIL, payload: error.response?.data?.detail || error.message })
    }
}


export const getPaymentTypeDetails = (id) => async (dispatch, getState) => {
    try {
        dispatch({ type: PAYMENT_TYPE_DETAILS_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const config = { headers: { Authorization: `Bearer ${userInfo.token}` } }
        const { data } = await axios.get(`/api/payment-types/${id}/`, config)
        dispatch({ type: PAYMENT_TYPE_DETAILS_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: PAYMENT_TYPE_DETAILS_FAIL, payload: error.response?.data?.detail || error.message })
    }
}


export const createPaymentType = (paymentTypeData) => async (dispatch, getState) => {
    try {
        dispatch({ type: PAYMENT_TYPE_CREATE_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const config = { headers: { Authorization: `Bearer ${userInfo.token}` } }
        const { data } = await axios.post('/api/payment-types/create/', paymentTypeData, config)
        dispatch({ type: PAYMENT_TYPE_CREATE_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: PAYMENT_TYPE_CREATE_FAIL, payload: error.response?.data?.detail || error.message })
    }
}


export const updatePaymentType = (id, paymentTypeData) => async (dispatch, getState) => {
    try {
        dispatch({ type: PAYMENT_TYPE_UPDATE_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const config = { headers: { Authorization: `Bearer ${userInfo.token}` } }
        const { data } = await axios.put(`/api/payment-types/update/${id}/`, paymentTypeData, config)
        dispatch({ type: PAYMENT_TYPE_UPDATE_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: PAYMENT_TYPE_UPDATE_FAIL, payload: error.response?.data?.detail || error.message })
    }
}


export const deletePaymentType = (id) => async (dispatch, getState) => {
    try {
        dispatch({ type: PAYMENT_TYPE_DELETE_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const config = { headers: { Authorization: `Bearer ${userInfo.token}` } }
        await axios.delete(`/api/payment-types/delete/${id}/`, config)
        dispatch({ type: PAYMENT_TYPE_DELETE_SUCCESS })
    } catch (error) {
        dispatch({ type: PAYMENT_TYPE_DELETE_FAIL, payload: error.response?.data?.detail || error.message })
    }
}


// ── User Payment Methods ────────────────────────────────────────────────────────

export const listUserPaymentMethods = () => async (dispatch, getState) => {
    try {
        dispatch({ type: USER_PAYMENT_METHOD_LIST_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const config = { headers: { Authorization: `Bearer ${userInfo.token}` } }
        const { data } = await axios.get('/api/users/payment-methods/', config)
        dispatch({ type: USER_PAYMENT_METHOD_LIST_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: USER_PAYMENT_METHOD_LIST_FAIL, payload: error.response?.data?.detail || error.message })
    }
}

export const addUserPaymentMethod = (paymentTypeId, accountDetails) => async (dispatch, getState) => {
    try {
        dispatch({ type: USER_PAYMENT_METHOD_ADD_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const config = { headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${userInfo.token}` } }
        const { data } = await axios.post('/api/users/payment-methods/add/', { payment_type: paymentTypeId, account_details: accountDetails }, config)
        dispatch({ type: USER_PAYMENT_METHOD_ADD_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: USER_PAYMENT_METHOD_ADD_FAIL, payload: error.response?.data?.detail || error.message })
    }
}

export const deleteUserPaymentMethod = (id) => async (dispatch, getState) => {
    try {
        dispatch({ type: USER_PAYMENT_METHOD_DELETE_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const config = { headers: { Authorization: `Bearer ${userInfo.token}` } }
        await axios.delete(`/api/users/payment-methods/delete/${id}/`, config)
        dispatch({ type: USER_PAYMENT_METHOD_DELETE_SUCCESS, payload: id })
    } catch (error) {
        dispatch({ type: USER_PAYMENT_METHOD_DELETE_FAIL, payload: error.response?.data?.detail || error.message })
    }
}
